import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=179a21dc&scoped=true&"
import script from "./SideBar.vue?vue&type=script&lang=js&"
export * from "./SideBar.vue?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=179a21dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179a21dc",
  null
  
)

export default component.exports